import { createRoute } from '@tanstack/react-router'
import rootRoute from './rootRoute'
import type { components } from '@/lib/client'
import { errorToast, toast } from '@/components/ui'
import { $api, $client } from '@/lib/fetch'
import EventForm from '@/components/EventForm'
import Loader from '@/components/Loader'
import { loggedInRouteLoader } from '@/lib/auth'

type CreateEvent = components['schemas']['CreateEvent']

function EditEventPage() {
  const { id } = eventEditRoute.useParams()

  const { isPending, error, data, refetch } = $api.useQuery(
    'get',
    '/api/events/id/{id}',
    { params: { path: { id: parseInt(id) } } },
  )

  if (isPending) return <Loader />

  if (error) {
    return (
      <div style={{ padding: 'var(--space-20)', textAlign: 'center' }}>
        Erreur: {JSON.stringify(error)}
      </div>
    )
  }

  const onSubmit = async (update: CreateEvent) => {
    const { error: updateError } = await $client.PATCH('/api/events/id/{id}', {
      params: { path: { id: parseInt(id) } },
      body: { event: update },
    })

    if (updateError) {
      if (updateError.detail === 'validation failed') {
        const named: Record<string, string> = {}
        updateError.errors?.forEach((e) => {
          const [, name] = (e.location || '').split('body.event.')
          if (e.message) named[name || ''] = e.message
        })
        return named
      }
      errorToast('Échec de la mise à jour', updateError)
      return
    }

    await refetch()
    toast({ color: 'success', title: 'Événement mis à jour !' })
  }

  return (
    <EventForm
      label="Modifier l'événement"
      onSubmit={onSubmit}
      event={data.event}
      isAdmin
    />
  )
}

export const eventEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/events/$id/edit',
  // Owners can reach the edit page for their own pending events; the backend
  // enforces the precise authorization (owner-of-pending or admin).
  loader: loggedInRouteLoader as any,
}).lazy(() => import('./EventEditPage.lazy').then((m) => m.Route))

export default EditEventPage
